import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Ponte tra i punti di ingresso dell'app (es. link nel footer) e il modal
 * delle preferenze cookie, montato una sola volta in app.component.
 */
@Injectable({ providedIn: 'root' })
export class CookieConsentService {
	private readonly openSource = new Subject<void>();
	/** Emette quando qualcuno richiede l'apertura del modal "Impostazioni cookie". */
	readonly open$ = this.openSource.asObservable();

	/** Riapre il modal per rivedere/modificare le preferenze. */
	openPreferences(): void {
		this.openSource.next();
	}
}
